import { useTranslation } from "react-i18next";
import InputForm from "../../../../../components/input/input-register/InputForm";
import PhoneNumberForm from "../../../../../components/input/input-register/PhoneNumberForm";
import SelectForm from "../../../../../components/input/input-register/SelectForm";
import {
    POSTAL_CODE_STATUS,
    PostalCodeStatusIcon,
    PostalCodeStatusMessage,
} from "../../../../../components/input/postal-code";

const BillingInformation = ({
    containerClass,
    formRefs,
    profileData,
    handleChangeProfile,
    errorsProfileData,
    optionsPronounce,
    setProfileData,
    handleLiClickCountryList3,
    isPostalCodeDisabled,
    isCityDisabled,
    postalCodeLookup,
}) => {
    const { t } = useTranslation();
    const isCheckingPostalCode = postalCodeLookup?.status === POSTAL_CODE_STATUS.CHECKING;

    return (
        <div className={containerClass}>
            <p className="tw:!text-[18px] tw:!font-[600] tw:!text-[#282828] tw:!mb-0">
                {t("businessRegister.billingInformation.title")} <span className="tw:!text-red-600">*</span>
            </p>
            <p className="tw:!text-[12px] tw:!font-[400] tw:!text-[#212529] tw:!mb-2">
                {t("businessRegister.billingInformation.desc")}
            </p>
            <div className="tw:flex tw:flex-col tw:md:flex-row tw:gap-0 tw:md:!gap-2 tw:lg:!gap-3 tw:mb-3">
                {/* Section 1: Honorific + Name */}
                <div className="tw:w-full tw:md:w-1/2 tw:flex tw:gap-1 tw:lg:!gap-3 tw:mb-3 tw:md:!mb-0">
                    <div className="tw:w-1/3 tw:md:w-1/4">
                        <SelectForm
                            name={"billingHonorifics"}
                            suffixClass={"mb-0 fs-14"}
                            isSearchable={false}
                            options={optionsPronounce}
                            defaultValue={optionsPronounce[0]}
                            value={optionsPronounce.find(item => item.value === profileData.billingHonorifics)}
                            onChange={(e) => {
                                console.log(e)
                                setProfileData({
                                    ...profileData,
                                    billingHonorifics: e.value,
                                })
                            }
                            }
                            label={t(
                                "businessRegister.authorizedRepresentativeContacts.form.honorifics"
                            )}
                            placeholder={t(
                                "businessRegister.authorizedRepresentativeContacts.form.honorifics"
                            )}
                        />
                    </div>

                    <div className="tw:w-full tw:md:w-3/4">
                        <InputForm
                            innerRef={formRefs.billingNameRef}
                            type={"text"}
                            suffixClass={"mb-0 fs-14"}
                            label={t("businessRegister.billingInformation.form.name")}
                            placeholder={t("businessRegister.billingInformation.form.name")}
                            id={"billingName"}
                            name={"billingName"}
                            value={profileData.billingName}
                            onChange={handleChangeProfile}
                            isInvalid={errorsProfileData.billingName}
                            invalidMessage={t(errorsProfileData.billingName)}
                        />
                    </div>
                </div>

                {/* Section 2: Phone Number */}
                <div className="tw:w-full tw:md:w-1/2">
                    <PhoneNumberForm
                        innerRef={formRefs.billingPhoneNumberRef}
                        id="billingPhoneNumber"
                        suffixClass={"mb-0 fs-14"}
                        name="billingPhoneNumber"
                        label={t("businessRegister.billingInformation.form.phoneNumber")}
                        placeholder={t("businessRegister.billingInformation.form.phoneNumber")}
                        countryCode={profileData.billingCountryCode}
                        prefixPhoneNumber={profileData.billingPrefixNumber}
                        value={profileData.billingPhoneNumber}
                        onClickCountryList={handleLiClickCountryList3}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.billingPhoneNumber}
                        invalidMessage={t(errorsProfileData.billingPhoneNumber)}
                    />
                </div>
            </div>


            <div className="tw:flex tw:flex-col tw:md:flex-row tw:gap-0 tw:md:!gap-2 tw:lg:!gap-3 tw:mb-3">
                <div className="tw:!w-full tw:md:!w-1/3 tw:mb-3 tw:md:!mb-0">
                    <InputForm
                        innerRef={formRefs.billingCountryRef}
                        type={"text"}
                        suffixClass={"mb-0 fs-14"}
                        label={t("businessRegister.billingInformation.form.country")}
                        placeholder={t("businessRegister.billingInformation.form.country")}
                        id={"billingCountry"}
                        name={"billingCountry"}
                        value={profileData.billingCountry}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.billingCountry}
                        invalidMessage={t(errorsProfileData.billingCountry)}
                        readOnly={true}
                        disable={true}
                    />
                </div>
                <div className="tw:!w-full tw:md:!w-1/3 tw:mb-3 tw:md:!mb-0">
                    <InputForm
                        innerRef={formRefs.billingPostalCodeRef}
                        type={"text"}
                        suffixClass={"mb-0 fs-14"}
                        label={t("businessRegister.billingInformation.form.postalCode")}
                        placeholder={t("businessRegister.billingInformation.form.postalCode")}
                        id={"billingPostalCode"}
                        name={"billingPostalCode"}
                        value={profileData.billingPostalCode}
                        onChange={handleChangeProfile}
                        // onBlur={checkPostalCodeHandler}
                        disable={isPostalCodeDisabled}
                        readOnly={isPostalCodeDisabled}
                        isInvalid={errorsProfileData.billingPostalCode}
                        invalidMessage={t(errorsProfileData.billingPostalCode)}
                        suffixIcon={<PostalCodeStatusIcon status={postalCodeLookup?.status} />}
                    />
                    <PostalCodeStatusMessage status={postalCodeLookup?.status} onRetry={postalCodeLookup?.retry} />
                </div>
                <div className="tw:!w-full tw:md:!w-1/3">
                    <InputForm
                        // innerRef={formRefs.billingCityRef}
                        type={"text"}
                        suffixClass={"mb-0 fs-14"}
                        label={t("businessRegister.billingInformation.form.city")}
                        placeholder={
                            isCheckingPostalCode
                                ? t("PostalCodeStatus.LookingUpCity")
                                : t("businessRegister.billingInformation.form.city")
                        }
                        id={"billingCity"}
                        name={"billingCity"}
                        value={profileData.billingCity}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.billingCity}
                        invalidMessage={t(errorsProfileData.billingCity)}
                        readOnly={isCityDisabled}
                        disable={isCityDisabled}
                    />
                </div>
            </div>

            <div className="tw:!flex tw:!flex-wrap tw:!mb-3 tw:!gap-3">
                <div className="tw:!flex-1">
                    <InputForm
                        innerRef={formRefs.billingAddressRef}
                        type={"text"}
                        suffixClass={"mb-0 fs-14"}
                        label={t("businessRegister.billingInformation.form.address")}
                        placeholder={t("businessRegister.billingInformation.form.address")}
                        id={"billingAddress"}
                        name={"billingAddress"}
                        value={profileData.billingAddress}
                        onChange={handleChangeProfile}
                        isInvalid={errorsProfileData.billingAddress}
                        invalidMessage={t(errorsProfileData.billingAddress)}
                    />
                </div>
            </div>
        </div>
    );
};

export default BillingInformation;
